(function twoNuGlassDockModule(scope) {
  "use strict";
  const layers = new Set(["menu", "language", "activity", "support", "cart", "compare", "account"]);
  function previewBottomInset(rect, height, top = 0) {
    if (!rect || ![rect.top, rect.bottom, rect.height, height, top].every(Number.isFinite)
      || height <= 0 || top < 0 || rect.height <= 0 || rect.height > height / 2
      || rect.top >= top + height || rect.bottom < top + height - 2) return 0;
    return Math.max(0, Math.ceil(top + height - Math.max(top, rect.top)));
  }
  function popupGeometry(height, top, layoutHeight, previewInset, dockHeight) {
    const dockTop = top + height - previewInset - dockHeight;
    return { bottom: Math.max(8, layoutHeight - dockTop + 8), maxHeight: Math.max(80, dockTop - top - 16) };
  }
  function createLayerCoordinator(close) {
    let active = null;
    return Object.freeze({
      select(next) {
        if (!layers.has(next)) return false;
        for (const layer of layers) if (layer !== next) close(layer);
        active = next;
        return true;
      },
      closed(layer) { if (active === layer) active = null; },
      get active() { return active; },
    });
  }
  if (typeof module === "object" && module.exports) module.exports = { createLayerCoordinator, previewBottomInset, popupGeometry };
  if (!scope.document) return;
  const document = scope.document;
  if (scope.twoNuGlassDockReady) return;
  scope.twoNuGlassDockReady = true;

  function removeLegacyActions() {
    // These utilities were also retired by the previous global controller.
    // Retain anchor links and the real product purchase forms.
    document.querySelectorAll([
      ".two-nu-home-dock__control", ".two-nu-home-dock__cart", ".two-nu-home-dock__whatsapp",
      ".two-nu-page-dock > .two-nu-page-dock__control", ".two-nu-page-dock > .two-nu-page-dock__icon",
      "[data-two-nu-product-dock] .two-nu-product-dock__control",
      "[data-two-nu-product-dock] .two-nu-product-dock__cart",
      "[data-two-nu-product-dock] .two-nu-product-dock__whatsapp",
    ].join(",")).forEach(node => { if (!node.closest(".two-nu-global-dock-section")) node.remove(); });
  }
  function bind() {
    const root = document.querySelector("[data-two-nu-glass-dock]");
    if (!root) return;
    removeLegacyActions();
    if (root.dataset.glassBound) return;
    root.dataset.glassBound = "true";
    const abort = new AbortController();
    const on = (node, name, handler, options = {}) => node?.addEventListener(name, handler, { ...options, signal: abort.signal });
    // Preserve the shared theme's input-modality contract. Safari can mark a
    // script-focused title as focus-visible after a tap; that is not keyboard
    // navigation and must not paint the old large focus frame.
    const markPointer = () => document.documentElement.setAttribute('data-two-nu-input-modality', 'pointer');
    const navigationKeys = new Set(['Tab','ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Enter',' ','Escape','Home','End','PageUp','PageDown']);
    on(document, 'pointerdown', markPointer, { capture: true, passive: true });
    on(document, 'touchstart', markPointer, { capture: true, passive: true });
    on(document, 'keydown', event => { if (navigationKeys.has(event.key)) document.documentElement.setAttribute('data-two-nu-input-modality', 'keyboard'); }, { capture: true });
    const support = root.querySelector("[data-two-nu-support-trigger]");
    const supportIndicator = root.querySelector("[data-glass-support-busy]");
    const compare = root.querySelector("[data-glass-compare]");
    let available = false, supportOpen = false, widgetBusy = false, switching = null, frame = 0;
    let pendingSupport = null, feedbackTimer = 0, lastCount = 0;
    let observedPreview = null, lastDockHeight = 52, lastDockWidth = 0, lastDockCenter = 0;
    const previewResize = typeof ResizeObserver === "function" ? new ResizeObserver(scheduleLayout) : null;
    const previewAttributes = new MutationObserver(scheduleLayout);
    const previewDiscovery = new MutationObserver(scheduleLayout);
    previewDiscovery.observe(document.documentElement, { childList: true, subtree: true });
    function setLayoutProperty(name, value) {
      if (document.documentElement.style.getPropertyValue(name) !== value) document.documentElement.style.setProperty(name, value);
    }
    function renderSupportState() {
      if (!support) {
        if (supportIndicator) supportIndicator.hidden = true;
        return;
      }
      const pending = !available && pendingSupport !== null;
      support.setAttribute("aria-controls", "TwoNuSupportChatPanel");
      support.setAttribute("aria-expanded", String(supportOpen || pending));
      if (pending || widgetBusy) support.setAttribute("aria-busy", "true");
      else support.removeAttribute("aria-busy");
      if (supportIndicator) supportIndicator.hidden = !(pending || widgetBusy);
    }
    function cancelPendingSupport(restoreFocus = false) {
      const trigger = pendingSupport;
      pendingSupport = null;
      if (!available) {
        const panel = document.querySelector('[data-support-chat-panel]');
        if (panel) panel.hidden = true;
        supportOpen = false;
      }
      renderSupportState();
      coordinator.closed("support");
      if (restoreFocus && trigger?.isConnected !== false) trigger?.focus?.({ preventScroll: true });
    }
    const coordinator = createLayerCoordinator(layer => {
      if (layer === "support") {
        document.dispatchEvent(new CustomEvent("two-nu:support:close", { detail: { restoreFocus: false } }));
      } else if (layer === "menu" || layer === "language") {
        if (!["menu", "language"].includes(switching)) scope.twoNuCloseDockPopovers?.({ immediate: true, focus: false });
      } else if (layer === "cart") scope.twoNuCloseDockCart?.({ immediate: true, focus: false });
      else if (layer === "activity") scope.twoNuCloseActivitySelector?.("dock-switch", { persist: false, focus: false, immediate: true });
      else if (layer === "compare") scope.TwoNuCompare?.close?.("dock-switch", { suppressFocusRestore: true, immediate: true });
    });
    function select(layer) {
      if (layer !== "support") cancelPendingSupport();
      switching = layer;
      try { coordinator.select(layer); } finally { switching = null; }
    }
    const utilities = document.querySelector("[data-glass-menu-utilities]");
    const menuBody = document.querySelector("#TwoNuCollectionDockMenu-global .two-nu-page-dock__popover-scroll");
    if (utilities && menuBody) { menuBody.prepend(utilities); utilities.hidden = false; }

    function anchorGroups() {
      const groups = [];
      document.querySelectorAll(".two-nu-home-dock").forEach(dock => {
        const links = Array.from(dock.querySelectorAll(".two-nu-home-dock__nav > a[data-dock-link], .two-nu-home-dock__nav > a[data-two-nu-dock-anchor]"));
        if (links.length) groups.push(links);
      });
      document.querySelectorAll(".two-nu-page-dock").forEach(dock => {
        const links = Array.from(dock.children).filter(child => child.tagName === "A" && !child.matches(".two-nu-page-dock__icon,.two-nu-page-dock__cart,.two-nu-page-dock__whatsapp"));
        if (links.length) groups.push(links);
      });
      document.querySelectorAll("[data-two-nu-product-dock]").forEach(dock => {
        const links = Array.from(dock.querySelectorAll("a[data-product-dock-link]"));
        if (links.length) groups.push(links);
      });
      return groups;
    }
    function updateLayout() {
      frame = 0;
      const viewport = scope.visualViewport;
      const height = viewport?.height || scope.innerHeight;
      const top = viewport?.offsetTop || 0;
      const width = viewport?.width || scope.innerWidth;
      const previewBar = document.getElementById("PBarNextFrameWrapper");
      if (previewBar !== observedPreview) {
        previewResize?.disconnect(); previewAttributes.disconnect(); observedPreview = previewBar;
        if (previewBar) {
          previewResize?.observe(previewBar);
          previewAttributes.observe(previewBar, { attributes: true, attributeFilter: ["style", "class", "hidden"] });
        }
      }
      const previewStyle = previewBar ? scope.getComputedStyle(previewBar) : null;
      const previewVisible = previewStyle && previewStyle.display !== "none" && previewStyle.visibility !== "hidden";
      const previewInset = previewBottomInset(previewVisible ? previewBar.getBoundingClientRect() : null, height, top);
      setLayoutProperty("--two-nu-glass-viewport-bottom", (top + height) + "px");
      setLayoutProperty("--two-nu-glass-preview-inset", previewInset + "px");
      const textEntry = document.activeElement?.matches("input:not(:disabled),textarea:not(:disabled),[contenteditable='true']") && document.activeElement?.closest("[data-two-nu-support-chat]");
      const hideForKeyboard = Boolean(textEntry && viewport && scope.innerHeight - height - top > 80);
      // Retain the last usable inset while the keyboard temporarily hides the dock.
      // On a late first bind, measure before hiding so width/center cannot be zero.
      if (!hideForKeyboard || lastDockWidth <= 0) {
        root.hidden = false;
        const dockBox = root.getBoundingClientRect();
        lastDockHeight = Math.ceil(dockBox.height || lastDockHeight);
        lastDockWidth = dockBox.width;
        lastDockCenter = dockBox.left + dockBox.width / 2;
      }
      root.hidden = hideForKeyboard;
      setLayoutProperty("--two-nu-support-navigation-inset", (lastDockHeight + 8) + "px");
      setLayoutProperty("--two-nu-support-inline-clearance", "8px");
      setLayoutProperty("--two-nu-glass-dock-width", lastDockWidth + "px");
      setLayoutProperty("--two-nu-glass-popup-center", lastDockCenter + "px");
      const popup = popupGeometry(height, top, scope.innerHeight, previewInset, hideForKeyboard ? 0 : lastDockHeight);
      setLayoutProperty("--two-nu-glass-popup-bottom", popup.bottom + "px");
      setLayoutProperty("--two-nu-glass-popup-max-height", popup.maxHeight + "px");
      for (const links of anchorGroups()) {
        if (width < 750) {
          links.forEach(link => { link.style.removeProperty("--two-nu-global-anchor-top"); link.removeAttribute("data-two-nu-global-anchor"); });
          continue;
        }
        const sizes = links.map(link => { link.setAttribute("data-two-nu-global-anchor", "true"); return Math.max(44, Math.ceil(link.getBoundingClientRect().height || 44)); });
        let y = Math.round(top + height / 2 - (sizes.reduce((a,b) => a+b, 0) + (links.length - 1) * 8) / 2);
        links.forEach((link,i) => { link.style.setProperty("--two-nu-global-anchor-top", y + "px"); y += sizes[i] + 8; });
      }
    }
    function scheduleLayout() { if (!frame) frame = scope.requestAnimationFrame(updateLayout); }
    function updateCompare(count = scope.TwoNuCompare?.items?.length || 0) {
      if (!Number.isInteger(count) || count < 0) return;
      const badge = compare.querySelector("[data-two-nu-compare-count]");
      badge.textContent = count ? String(count) : "";
      badge.classList.toggle("is-empty", count === 0);
      badge.setAttribute("aria-hidden", String(count === 0));
      if (count > lastCount) {
        compare.classList.add("is-updated");
        scope.clearTimeout(feedbackTimer);
        feedbackTimer = scope.setTimeout(() => compare.classList.remove("is-updated"), 700);
      }
      lastCount = count;
    }
    on(document, "click", event => {
      const target = event.target.closest?.("[data-two-nu-global-control], [data-two-nu-support-trigger], [data-two-nu-compare-open], [data-two-nu-open-activity-selector], [data-two-nu-dock-cart-link]");
      if (!target) return;
      // Dock WhatsApp opens wa.me directly — never the support chat panel.
      if (target.matches("[data-support-whatsapp-link], [data-two-nu-global-control='whatsapp']") || target.dataset.twoNuGlobalControl === "whatsapp") {
        cancelPendingSupport();
        return;
      }
      const layer = target.dataset.twoNuGlobalControl || (target.matches("[data-two-nu-support-trigger]") ? "support" : target.matches("[data-two-nu-compare-open]") ? "compare" : target.matches("[data-two-nu-open-activity-selector]") ? "activity" : "cart");
      if(layer === "account") { if(!target.querySelector("[data-two-nu-account-open]"))select("account"); return; }
      select(layer);
      if (layer === "support") {
        event.preventDefault();
        const closeWanted = target === support && (supportOpen || pendingSupport !== null);
        if (available) document.dispatchEvent(new CustomEvent(closeWanted ? "two-nu:support:close" : "two-nu:support:open", { detail: { trigger: target, restoreFocus: false } }));
        else {
          pendingSupport = closeWanted ? null : target;
          const chat = document.querySelector('[data-two-nu-support-chat]');
          const panel = chat?.querySelector('[data-support-chat-panel]');
          if (chat && panel) {
            const wasHidden = panel.hidden;
            chat.hidden = false;
            panel.hidden = closeWanted;
            const launcher = chat.querySelector('[data-support-chat-launcher]');
            if (launcher) launcher.hidden = true;
            if (!closeWanted && wasHidden) panel.querySelector('[data-support-chat-close]')?.focus({ preventScroll: true });
          }
          renderSupportState();
          document.dispatchEvent(new CustomEvent('two-nu:support:request-state'));
        }
      }
    }, { capture: true });
    on(document, "click", event => {
      if (!available && pendingSupport && event.target.closest?.('[data-support-chat-close]')) {
        cancelPendingSupport(true);
      }
    });
    on(document, "keydown", event => {
      if(event.key==='Escape'&&!available&&pendingSupport){
        event.preventDefault();cancelPendingSupport(true);
      }
    });
    on(document, 'pointerdown', event => {
      if (available || !pendingSupport || event.target.closest?.('[data-two-nu-support-trigger]')) return;
      const panel = document.querySelector('[data-support-chat-panel]');
      if (!panel?.contains(event.target)) cancelPendingSupport();
    });
    on(scope, 'pagehide', () => { if (pendingSupport) cancelPendingSupport(); });
    on(document, 'two-nu:support:close', () => cancelPendingSupport());
    on(document, "two-nu:support:state", event => {
      const state = event.detail || {};
      available = state.available === true;
      supportOpen = available && state.open === true;
      widgetBusy = available && state.busy === true;
      renderSupportState();
      if(available&&pendingSupport){const trigger=pendingSupport;pendingSupport=null;select('support');document.dispatchEvent(new CustomEvent('two-nu:support:open',{detail:{trigger}}));scheduleLayout();return;}
      if (supportOpen) select("support"); else coordinator.closed("support");
      scheduleLayout();
    });
    on(document, "two-nu:compare-change", event => updateCompare(event.detail?.count));
    on(scope, "resize", scheduleLayout, { passive: true });
    on(scope, "twoNu:viewportchange", scheduleLayout);
    on(scope.visualViewport, "resize", scheduleLayout, { passive: true });
    on(scope.visualViewport, "scroll", scheduleLayout, { passive: true });
    on(document, "focusin", scheduleLayout);
    on(document, "focusout", scheduleLayout);
    on(document, "shopify:section:load", scheduleLayout);
    on(document, "shopify:section:unload", event => {
      if (!event.target.contains(root)) return;
      if (pendingSupport) cancelPendingSupport();
      abort.abort();
      previewResize?.disconnect(); previewAttributes.disconnect(); previewDiscovery.disconnect();
      if (frame) scope.cancelAnimationFrame(frame);
      scope.clearTimeout(feedbackTimer);
      document.body.classList.remove("two-nu-glass-ready");
      for (const key of ["--two-nu-support-navigation-inset","--two-nu-support-inline-clearance","--two-nu-glass-viewport-bottom","--two-nu-glass-preview-inset","--two-nu-glass-popup-bottom","--two-nu-glass-popup-max-height","--two-nu-glass-dock-width","--two-nu-glass-popup-center"]) document.documentElement.style.removeProperty(key);
      delete root.dataset.glassBound;
    });
    document.body.classList.add("two-nu-glass-ready");
    updateLayout();
    updateCompare();
    document.dispatchEvent(new CustomEvent("two-nu:support:request-state"));
  }
  document.addEventListener("shopify:section:load", bind);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind, { once: true }); else bind();
})(typeof window === "object" ? window : globalThis);
